export default "__VITE_IMAGE_ASSET__6d1578be__";